import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './SolarBESS.css';
import { useNavigate } from 'react-router-dom';


// Importing images from assets/Project/Project4
import heroImg from '../../assets/Project/Project4/Image.png';
import image1 from '../../assets/Project/Project4/Image1.png';
import image2 from '../../assets/Project/Project4/Image2.png';
import image3 from '../../assets/Project/Project4/Image3.png';
import image4 from '../../assets/Project/Project4/Image4.png';

// Keep the global references for bottom cards (from respective projects)
import card1Img from '../../assets/Project/image.png'; // Madhubani EPC
import card2Img from '../../assets/Project/image2.png'; // Reusing an image for the second Madhubani EPC reference
import card3Img from '../../assets/Project/image3.png'; // Samastipur Hybrid EPC (Using the container image for card3 given the design reference)
import CustomButton from '../Button/CustomButton';

const SolarBESS = () => {
          const navigate = useNavigate();

    return (
        <div className="solar-bess-page">
            {/* Hero Section */}
            <section className="solar-bess-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 hero-text-col">
                            <h1 className="hero-title">Solar + BESS EPC Project – 1 MW + 2 MWh</h1>
                            <h3 className="hero-location">Tamil Nadu</h3>
                            <p className="hero-description">
                                This project combines a 1 MW solar power plant with a 2 MWh battery energy storage system.
                                It was developed to provide stable and reliable power with improved energy management.
                            </p>
                              <CustomButton
                variant="white"
                size="lg"
                text=" Discuss Your Project"
                onClick={() => navigate("/contact")}
              />
                        </div>
                        <div className="col-lg-6 hero-image-col">
                            <img src={heroImg} alt="Solar + BESS Project Overview" className="hero-img img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Content Section */}
            <main className="solar-bess-content">
                <div className="container">
                    {/* Project Overview */}
                    <section className="content-section">
                        <h2>PROJECT OVERVIEW</h2>
                        <p>
                            This project was designed to provide consistent power even when sunlight is not available.
                            Unlike a regular solar plant, this hybrid system includes a battery storage solution. During the day, solar panels generate electricity. This project was designed to deliver clean energy with added storage support.
                            During the day, the solar plant generates electricity. The battery system stores excess power and supplies it when needed — especially during peak demand or low sunlight hours.
                            The main goal was to create a dependable and flexible energy solution. The extra energy is stored and used later when required.
                            The goal was simple — improve reliability and reduce power interruptions.
                        </p>
                    </section>

                    {/* Our Role */}
                    <section className="content-section">
                        <h2>OUR ROLE IN THIS PROJECT</h2>
                        <p>In this Solar + BESS EPC project, our team handled the complete execution process.</p>
                        <p>Our work included:</p>
                        <ul>
                            <li>Engineering design for solar and battery integration</li>
                            <li>Procurement of panels, inverters, and BESS units</li>
                            <li>Site preparation and structure installation</li>
                            <li>Battery container setup and system configuration</li>
                            <li>Electrical integration and safety checks</li>
                        </ul>
                    </section>

                    {/* Project Highlights */}
                    <section className="content-section">
                        <h2>PROJECT HIGHLIGHTS</h2>
                        <ul>
                            <li>1 MW solar power installation</li>
                            <li>2 MWh battery energy storage system</li>
                            <li>Located in Tamil Nadu</li>
                            <li>Designed for energy stability and peak demand support</li>
                        </ul>
                    </section>

                    {/* Execution Approach */}
                    <section className="content-section">
                        <h2>EXECUTION APPROACH</h2>
                        <ul>
                            <li>Mounting solar panels across the site</li>
                            <li>Installing battery storage containers</li>
                            <li>Integrating inverters and control systems</li>
                        </ul>
                    </section>

                    {/* Impact of the Project */}
                    <section className="content-section child-impact">
                        <h2>IMPACT OF THE PROJECT</h2>
                        <ul>
                            <li>This project improves power reliability by combining solar generation with storage backup.</li>
                            <li>It helps reduce stress on the grid during peak hours and ensures consistent energy supply.</li>
                            <li>By integrating storage, the system becomes more flexible and future-ready.</li>
                        </ul>
                    </section>

                    {/* Image Grid */}
                    <section className="image-grid-section">
                        <div className="row image-grid">
                            <div className="col-md-6 grid-item">
                                <img src={image1} alt="Solar Panels field" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item">
                                <img src={image2} alt="Engineer inspecting BESS" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item mt-4 mt-md-0 pt-md-4">
                                <img src={image3} alt="Solar Panels structural support" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item mt-4 mt-md-0 pt-md-4">
                                <img src={image4} alt="Solar Panels rows" className="img-fluid grid-img" />
                            </div>
                        </div>
                    </section>

                    {/* Explore More Projects */}
                    <section className="explore-more-section">
                        <h2 className="explore-title">Explore More Renewable Energy Projects</h2>
                        <div className="row">
                            {/* Card 1 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-epc" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={card1Img} alt="Solar EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar EPC,<br />Madhubani, Bihar</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/* Card 2 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-epc" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={card2Img} alt="Solar EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar EPC,<br />Madhubani, Bihar</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/* Card 3 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-hybrid" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={card3Img} alt="Solar Hybrid EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar Hybrid EPC, Pusa,<br />Samastipur, Bihar</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
};

export default SolarBESS;
